// Per-product-category default spec rows, derived from real reference quotes.
// User can still edit / add / remove rows freely after selecting a category.
export const CATEGORIES = [
  { value: "", label: "— Select category —", labels: [] },
  {
    value: "plastic_pallet",
    label: "Plastic Pallet (without steel)",
    labels: [
      "Model", "Size", "Type", "Material", "Runner", "Made in",
      "Color", "Warranty", "Weight", "Static Load", "Racking Load", "Dynamic Load",
    ],
  },
  {
    value: "plastic_pallet_steel",
    label: "Plastic Pallet (with steel rods)",
    labels: [
      "Model", "Size", "Type", "Material", "Runner", "Steel Rod", "Made in",
      "Color", "Warranty", "Weight", "Static Load", "Racking Load", "Dynamic Load",
    ],
  },
  {
    value: "plastic_storage_bin",
    label: "Plastic Storage Bin",
    labels: ["Model", "Size", "Type", "Warranty", "Material", "Color", "Food Grade"],
  },
  {
    value: "garbage_bin",
    label: "Garbage Bin",
    labels: ["Model", "Capacity", "Size", "Type", "Material", "Color", "Wheels"],
  },
  {
    value: "ss_bin",
    label: "Stainless Steel Bin",
    labels: ["Model", "Capacity", "Size", "Type", "Material"],
  },
  {
    value: "bucket",
    label: "Bucket",
    labels: ["Model", "Capacity", "Size", "Material", "Color", "Food Grade"],
  },
  {
    value: "crate",
    label: "Crate",
    labels: ["Model", "Size", "Type", "Material", "Stackable", "Color"],
  },
  {
    value: "jerry_can",
    label: "Jerry Can",
    labels: ["Model", "Capacity", "Size", "Material", "Weight", "Food Grade", "Color"],
  },
  {
    value: "hand_pallet_trolley",
    label: "Hand Pallet Trolley",
    labels: [
      "Model", "Capacity", "Fork Length", "Width over Fork",
      "Total Lift Height", "Minimum Fork Height",
      "Brand", "Made in", "Color", "Wheel", "Warranty",
    ],
  },
  { value: "custom", label: "Custom (blank)", labels: [] },
];

export const buildSpecsForCategory = (catValue) => {
  const cat = CATEGORIES.find((c) => c.value === catValue);
  if (!cat) return [];
  return cat.labels.map((l) => ({ label: l, value: "" }));
};
